"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const styles_1 = require("./styles");
const DrawerFooter = (0, material_1.styled)(Box_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    height: styles_1.DRAWER_FOOTER_HEIGHT,
    paddingTop: theme.spacing(0.5),
    position: "fixed",
    width: "280px",
    bottom: 0,
    left: 0,
    borderRight: `1px solid ${theme.palette.divider}`,
    ...(open && (0, styles_1.openedMixin)(theme)),
    ...(!open && (0, styles_1.closedMixin)(theme)),
    overflow: "hidden",
}));
exports.default = DrawerFooter;
